<div class="d-flex flex-column" style="min-width: 600px;" [formGroup]="editForm">
    <label>Email</label>
    <div class="row">
        <div class="col-12 row">
            <div class="col-6">
                <input class="form-control" formControlName="receiver">
                <!-- <div class="d-flex">
                    <app-error-text [isDisplay]="errors.email"
                        [message]="'Có email cần được thêm vào.'">
                    </app-error-text>
                </div> -->
            </div>
            <div class="col-6">
                <button class="ant-btn ng-star-inserted ant-btn-primary" (click)="addEmail()">Add</button>
                <button class="ant-btn ng-star-inserted ant-btn-default ml-3" (click)="cleanEmail()">Clean</button>
            </div>
        </div>
        <div class="col-12" *ngIf="summaryReceivers?.length">
            <div class="d-flex flex-wrap tag-container">
                <div class="tag-item" *ngFor="let tag of summaryReceivers; index as index">
                    <span>{{tag}}</span>
                    <span class="delete-icon" (click)="deleteTag(index)">x</span>
                </div>
            </div>
            <div class="d-flex" *ngIf="summaryReceivers?.length < receivers.length">
                <h3>Còn nữa ...</h3>
            </div>
        </div>
    </div>
</div>